"use client";

import { Icon } from "./Icon";
import { cn } from "@/lib/utils";

interface PaginationProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  className?: string;
}

export function Pagination({
  page,
  totalPages,
  onPageChange,
  className = "",
}: PaginationProps) {
  const pages = Array.from({ length: totalPages }, (_, i) => i + 1);

  return (
    <nav
      aria-label="Pagination"
      className={cn("flex items-center gap-1", className)}
    >
      <button
        type="button"
        aria-label="Previous page"
        disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}
        className="flex h-8 w-8 items-center justify-center rounded-full text-muted transition hover:bg-secondary/5 disabled:opacity-40"
      >
        <Icon name="chevron-left" size={16} />
      </button>

      {pages.map((pageNumber) => {
        const isActive = pageNumber === page;
        return (
          <button
            key={pageNumber}
            type="button"
            aria-label={`Page ${pageNumber}`}
            aria-current={isActive ? "page" : undefined}
            onClick={() => onPageChange(pageNumber)}
            className={cn(
              "flex h-8 w-8 items-center justify-center rounded-full text-sm font-medium transition",
              isActive
                ? "bg-primary text-white"
                : "text-muted hover:bg-secondary/5",
            )}
          >
            {pageNumber}
          </button>
        );
      })}

      <button
        type="button"
        aria-label="Next page"
        disabled={page >= totalPages}
        onClick={() => onPageChange(page + 1)}
        className="flex h-8 w-8 items-center justify-center rounded-full text-muted transition hover:bg-secondary/5 disabled:opacity-40"
      >
        <Icon name="chevron-right" size={16} />
      </button>
    </nav>
  );
}
